import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PlugZap, ArrowRight } from "lucide-react";

export default function GHLNotConnected({ icon: Icon, title, description }) {
  return (
    <Card className="flex flex-col items-center justify-center rounded-2xl border-dashed border-navy-100 bg-white/70 py-20 text-center shadow-none" data-testid="ghl-not-connected">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-navy-900">
        <Icon className="h-8 w-8 text-gold-400" />
      </div>
      <h3 className="mt-5 font-serif text-xl font-bold text-navy-900">{title}</h3>
      <p className="mt-2 max-w-md text-navy-500">{description}</p>
      <Link to="/settings">
        <Button data-testid="connect-ghl-from-empty" className="mt-6 rounded-full bg-gold-500 px-6 text-white hover:bg-gold-600">
          <PlugZap className="mr-2 h-4 w-4" /> Connect GoHighLevel <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </Link>
    </Card>
  );
}
